import classic from './classic/index.jsx';
import eightBit from './eightbit/index.jsx';

// The bookshelf module: the books, and the themes that draw them.
//
// A module owns its payload shape. The API hands back {id, module, payload,
// ...}; only this file knows a bookshelf payload is a Book.
//
// A *theme* owns the screen. Everything below unwrap is a way of drawing the
// same books - a room's bookshelf, or a side-scrolling level - and they share
// the shelf grouping, the sort order and the colour a book is, and nothing
// else. Adding a third is adding a directory and a line here.
export default {
  id: 'bookshelf',
  label: 'Bookshelf',

  unwrap(items) {
    return items.map((item) => item.payload).filter(Boolean);
  },

  themes: [classic, eightBit],

  // Which one a display draws with, from its account's settings. Anything
  // unrecognised falls back to the first rather than to nothing, so a value
  // written by a newer admin site costs a screen its theme and not its books.
  themeFor(settings = {}) {
    return this.themes.find((theme) => theme.id === settings.bookshelfTheme) || this.themes[0];
  },
};
